import React from 'react'
import '@ant-design/compatible/assets/index.css';
import { Button, message } from "antd";
import * as FileSaver from 'file-saver';
import _ from 'lodash';
import { FileExcelOutlined } from '@ant-design/icons';
export const ExportSftpLog = ({logData}) => {

  
    const ExportSftpLog = (logData ) => {
        if(logData != null){
            try{
                var data = logData
                var fileName = 'SFTP log.json';
                
                // Create a blob of the data
                var fileToSave = new Blob([JSON.stringify(data,undefined,2)], {
                    type: 'application/json'
                });
                
                // Save the file
                FileSaver.saveAs(fileToSave, fileName);
         
            }catch (err){
                message.error(err)
            } 
        }
        else{
            message.error('There are no valid data to export');
        }
     
    }

    return (
        <Button icon={<FileExcelOutlined />} type="primary" style={{marginBottom:'15px'}} onClick={(e) => ExportSftpLog(logData)}>Export</Button>
        )
}

export default ExportSftpLog;